module.exports={author:"Hedgie Choi",date:"10/17/2019",publishDate:"10/17/2019",highlighted:!1,tags:"",title:"I Get It, Phases"};